import store from '../store';

type FlashMessengerType = 'default' | 'success' | 'info' | 'error';

const icons = {
    'default': 'info',
    'success': 'check',
    'info': 'info',
    'error': 'error',
};

export default class FlashMessenger
{
    private static _addMessage(type: FlashMessengerType, text: string, reset = false, id: Nullable<string> = null)
    {
        let message: FlashMessageData = {
            id: null,
            class: type,
            icon: icons[type],
            text,
        };

        if (reset || id)
        {
            this.resetMessages(id);
        }
        if (id)
        {
            message.id = id;
        }

        store.commit('flashMessageAdd', message);
    }

    static resetMessages(id?: Nullable<string>)
    {
        // delete by id
        if (id)
        {
            for (let key in store.state.flashMessages)
            {
                if (store.state.flashMessages.hasOwnProperty(key) && store.state.flashMessages[key].id === id)
                {
                    store.commit('flashMessageRemove', parseInt(key));
                    break;
                }
            }
        }
        // delete all
        else
        {
            store.commit('flashMessageReset');
        }
    }

    static addMessage(type: FlashMessengerType, text: string, reset = false, id: Nullable<string> = null)
    {
        this._addMessage(type, text, reset, id);
    }

    static addSuccessMessage(text: string, reset = false, id: Nullable<string> = null)
    {
        this._addMessage('success', text, reset, id);
    }

    static addInfoMessage(text: string, reset = false, id: Nullable<string> = null)
    {
        this._addMessage('info', text, reset, id);
    }

    static addErrorMessage(text: string, reset = false, id: Nullable<string> = null)
    {
        this._addMessage('error', text, reset, id);
    }
}